import { render, staticRenderFns } from "./priceItem.vue?vue&type=template&id=13ae9570"
import script from "./priceItem.vue?vue&type=script&lang=js"
export * from "./priceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports